/**
 * Modified by Russell Dempsey on 2021 DEC 15
 * @see https://stackoverflow.com/a/62002044/592760
 */

class Observable<T> {
  private subscribers = new Set<Subscriber<T>>();

  public constructor(private value: T) {}

  public get(): T {
    return this.value;
  }

  public set(newValue: T): void {
    if (this.value === newValue) return;

    this.value = newValue;
    this.subscribers.forEach((listener) => listener(this.value));
  }

  public subscribe(subscriber: Subscriber<T>): () => void {
    this.subscribers.add(subscriber);

    return () => this.unsubscribe(subscriber);
  }

  public unsubscribe(subscriber: Subscriber<T>): void {
    this.subscribers.delete(subscriber);
  }
}

export type Subscriber<T> = (value: T) => void;

export { Observable };
